<template>
  <div>
    <div class="pa-3">
      <v-container>
        <div style="text-align: center" class="py-2 mb-3">
          <img style="height: 50%; width: 100px" src="../assets/logo.svg" />
        </div>
        <v-tabs
          class="Kanit"
          background-color="white"
          color="#0A4EA2"
          grow
          show-arrows
        >
          <v-tab :key="'login'">เข้าสู่ระบบ</v-tab>
          <!-- <v-tab :key="'register'">สมัครสมาชิก</v-tab> -->
          <v-tab-item :key="'login'">
            <ValidationObserver ref="observer" tag="form">
              <form class="mt-8">
                <ValidationProvider
                  :name="'บัญชีผู้ใช้'"
                  :rules="'required'"
                  key="Phone"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    color="#0A4EA2"
                    prepend-inner-icon="mdi-account-lock"
                    :error-messages="errors"
                    type="number"
                    v-model="input.phone"
                    placeholder="บัญชีผู้ใช้ (เบอร์โทรศัพท์)"
                  ></v-text-field>
                </ValidationProvider>
                <ValidationProvider
                  :name="'รหัสผ่าน'"
                  :rules="'required'"
                  key="Password"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    color="#0A4EA2"
                    prepend-inner-icon="mdi-lock"
                    :error-messages="errors"
                    :append-icon="showPassword1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword1 ? 'text' : 'password'"
                    @click:append="showPassword1 = !showPassword1"
                    v-model="input.password"
                    placeholder="รหัสผ่าน"
                  ></v-text-field>
                </ValidationProvider>
              </form>
            </ValidationObserver>
            <div class="mt-9">
              <v-btn
                large
                style="border-radius: 15px"
                :loading="saveloading"
                @click="login"
                block
                dark
                color="#0A4EA2"
                >เข้าสู่ระบบ</v-btn
              >
              <div class="text-center mt-3">
                <v-btn
                  @click="query.view = 'ForgetPassword'"
                  text
                  rounded
                  style="color: darkgrey"
                  >แจ้งลืมพาสเวิร์ด</v-btn
                >
              </div>
            </div>
          </v-tab-item>
          <v-tab-item :key="'register'">
            <OTP :noheader="true"></OTP>
          </v-tab-item>
        </v-tabs>
      </v-container>
    </div>
  </div>
</template>

<script>
import OTP from "./OTP.vue";
import axios from "axios";

export default {
  components: {
    OTP,
  },
  data() {
    return {
      show: false,
      saveloading: false,
      input: { phone: "", password: "" },
      showPassword1: false,
    };
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
  },
  methods: {
    async login() {
      var vm = this;
      if (!vm.saveloading) {
        var data = {
          userid: this.$store.state.userid,
          apptype: this.query.apptype,
          pageid: vm.query.pageid,
          phoneno: vm.input.phone,
          password: vm.input.password,
        };
        var isValid = await vm.$refs.observer.validate();
        if (isValid) {
          vm.saveloading = true;
          axios
            .post(
              "https://communitybotbyzwizai.herokuapp.com/toaloginmember",
              data,
              {
                headers: { AUTHORIZATION: "Bearer xxx xxx" },
              }
            )
            .then(async (response) => {
              if (response.data && response.data.responsecode == 400) {
                await this.$swal.fire({
                  icon: "error",
                  text: response.data.reason,
                });
                vm.saveloading = false;
              } else if (response.data.responsecode == 200) {
                if (vm.$store.state.registerType == "dealer") {
                  await vm.toadealerregister(vm.$store.state.registerData);
                } else if (vm.$store.state.registerType == "customer") {
                  await vm.toacustomerConsent();
                  await vm.toacustomerregister(vm.$store.state.registerData);
                } else if (vm.$store.state.registerType == "customerform") {
                  await vm.toacustomerConsent();
                  await vm.toacustomerform(vm.$store.state.registerData);
                } else if (vm.$store.state.registerType == "painter") {
                  await vm.toapainterregister(vm.$store.state.registerData);
                } else if (vm.$store.state.redirect) {
                  vm.query.view = vm.$store.state.redirect;
                } else if (vm.query.user_type == "customer") {
                  vm.query.view = "CustomerForm";
                } else {
                  if (this.query.apptype == "line") {
                    await this.$liff.closeWindow();
                  } else if (this.query.apptype == "facebook") {
                    this.$store.dispatch("messengerClose");
                  }
                  // vm.query.view = "Register";
                }
              } else {
                vm.$swal.fire({
                  icon: "error",
                  text: "เบอร์โทร หรือ รหัสผ่านไม่ถูกต้อง",
                });
              }
              vm.saveloading = false;
            });
        }
      }
    },
    async toapainterregister(data) {
      var vm = this;
      return new Promise((resolve) => {
        vm.saveloading = true;
        axios
          .post(
            "https://communitybotbyzwizai.herokuapp.com/toaregisterpainter",
            data,
            { headers: { AUTHORIZATION: "Bearer xxx xxx" } }
          )
          .then(async (response) => {
            vm.saveloading = false;
            if (response.data && response.data.responsecode == 400) {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
              });
              resolve();
            } else if (response.data.responsecode == 200) {
              await this.$swal.fire({
                icon: "success",
                text: "ลงทะเบียนสำเร็จ",
                confirmButtonText: "ตกลง",
              });
              if (this.query.apptype == "line") {
                await this.$liff.closeWindow();
              } else if (this.query.apptype == "facebook") {
                this.$store.dispatch("messengerClose");
              }
              resolve();
              //   this.query.view = "SelectPainter";
            } else if (response.data.responsecode == 401) {
              await vm.$swal.fire({
                icon: "error",
                text: response.data.reason,
              });
              vm.query.view = "Login";
              vm.$store.state.redirect = "PainterForm";
              resolve();
            }
          });
      });
    },
    toacustomerregister(data) {
      var vm = this;
      return new Promise((resolve) => {
        axios
          .post(
            "https://communitybotbyzwizai.herokuapp.com/toainfocustomer-createaddress",
            data,
            {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            }
          )
          .then(async (response) => {
            vm.saveloading = false;
            vm.$store.state.redirect = "";
            if (response.data && response.data.responsecode == 400) {
              await vm.$swal.fire({
                icon: "error",
                text: response.data.reason,
              });
              resolve();
            } else if (response.data.responsecode == 200) {
              await vm.$swal.fire({
                text: "เพิ่มที่อยู่สำเร็จ",
                icon: "success",
              });
              vm.query.view = "CustomerAddress";
            } else if (response.data.responsecode == 401) {
              await vm.$swal.fire({
                icon: "error",
                text: response.data.reason,
              });
              vm.query.view = "Login";
              resolve();
            }
          });
      });
    },
    async toadealerregister(data) {
      var vm = this;
      return new Promise((resolve) => {
        axios
          .post(
            "https://communitybotbyzwizai.herokuapp.com/toaregister",
            data,
            {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            }
          )
          .then(async (response) => {
            this.saveloading = false;
            if (response.data && response.data.responsecode == 400) {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
                confirmButtonText: "ตกลง",
              });
              resolve();
            } else if (response.data.responsecode == 200) {
              await this.$swal.fire({
                icon: "success",
                text: "ลงทะเบียนสำเร็จ",
                confirmButtonText: "ตกลง",
              });
              if (this.query.apptype == "line") {
                await this.$liff.closeWindow();
              } else if (this.query.apptype == "facebook") {
                this.$store.dispatch("messengerClose");
              }
              resolve();
            } else if (response.data.responsecode == 401) {
              await vm.$swal.fire({
                icon: "error",
                text: response.data.reason,
              });
              vm.query.view = "Login";
              resolve();
            } else {
              vm.$swal.fire({
                icon: "error",
                text: "ลงทะเบียนไม่สำเร็จ",
              });
              resolve();
            }
          });
      });
    },
    toacustomerConsent() {
      var vm = this;
      return new Promise((resolve) => {
        axios
          .post(
            "https://communitybotbyzwizai.herokuapp.com/toaconsent",
            vm.$store.state.consentData,
            {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            }
          )
          .then(async (response) => {
            if (response.data && response.data.responsecode == 400) {
              await vm.$swal.fire({
                icon: "error",
                text: response.data.reason,
              });
              resolve();
            }
            if (response.data.responsecode == 200) {
              resolve();
            }
          });
      });
    },
    async toacustomerform(data) {
      var vm = this;

      vm.saveloading = true;

      axios
        .post(
          "https://communitybotbyzwizai.herokuapp.com/toapainterjobinfo",
          data,
          { headers: { AUTHORIZATION: "Bearer xxx xxx" } }
        )
        .then(async (response) => {
          vm.saveloading = false;
          if (response.data.responsecode == 200) {
            this.$store.state.orderid = response.data.data[0].orderid;
            await this.$swal.fire({
              icon: "success",
              text: "สำเร็จ",
            });
            if (this.query.apptype == "line") {
              await this.$liff.closeWindow();
            } else if (this.query.apptype == "facebook") {
              this.$store.dispatch("messengerClose");
            }
            // this.query.view = "SelectPainter";
          } else {
            await this.$swal.fire({
              icon: "error",
              text: response.data.reason,
            });
          }
        });
    },
  },
};
</script>